module.exports = __webpack_public_path__ + "img/video_anleitung_big.69802bf9.jpg";